/**
 * v0.4 追加要件⑮ (D-573): 人件費の確度トグル (予定/実績/見込み)。
 * `/shift/report/daily`・`/shift/report/employees`・編成ボードの3画面が共有する
 * (§8-55 型の食い違いを避けるため、ボタン列を画面ごとに個別実装しない)。
 */
import { LABOR_COST_CONFIDENCE_OPTIONS, type LaborCostConfidence } from '@/lib/shift-report-labels';

export function LaborCostConfidenceToggle({
  value, onChange, ariaLabel = '確度',
}: {
  value: LaborCostConfidence;
  onChange: (next: LaborCostConfidence) => void;
  ariaLabel?: string;
}) {
  return (
    <div className="flex items-center gap-1.5" role="group" aria-label={ariaLabel}>
      {LABOR_COST_CONFIDENCE_OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button" aria-pressed={value === opt.value}
          onClick={() => onChange(opt.value)}
          className={`min-h-[44px] px-3 rounded-full text-xs border ${value === opt.value ? 'bg-misespark-navy text-white border-misespark-navy' : 'border-surface-border text-text-body'}`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
